/**
 * Textos comerciales y datos de contacto del portal público de PUSAH.
 *
 * PROVISIONAL: pendiente de definir con mercadeo. Todo el texto del portal sale de este archivo,
 * así que ajustar la comunicación es editar aquí, sin tocar componentes.
 *
 * Los campos en `null` simplemente no se muestran: mientras no haya correo de contacto, el portal
 * no pinta el botón ni la sección correspondiente.
 */
export const PORTAL = {
  hero: {
    titular: 'Publicaciones digitales para tu organización',
    subtitulo:
      'PUSAH publica revistas, boletines y documentos institucionales en un visor interactivo, con la identidad de cada organización y sin que nadie tenga que instalar nada.',
    // Ancla a una sección de esta misma página.
    accionPrincipal: { texto: 'Ver publicaciones', ancla: '#organizaciones' },
    // Se muestra sólo si hay correo de contacto configurado más abajo.
    accionSecundaria: { texto: 'Quiero publicar con PUSAH' },
  },

  vitrina: {
    titulo: 'Publicaciones recientes',
    subtitulo: 'Lo último que han publicado las organizaciones de la plataforma',
    // Cuántas portadas se piden a la API.
    cantidad: 8,
  },

  directorio: {
    titulo: 'Organizaciones',
    subtitulo: 'Selecciona una organización para ver todas sus publicaciones',
    vacio: 'Aún no hay organizaciones publicadas en el portal.',
  },

  comoFunciona: {
    titulo: '¿Cómo funciona?',
    pasos: [
      {
        titulo: 'Cada organización con su marca',
        descripcion:
          'Logo, colores y textos propios. La organización puede usar su propio dominio o una dirección dentro de la plataforma.',
      },
      {
        titulo: 'Publicar es subir un PDF',
        descripcion:
          'Desde el panel se crean las categorías y se suben los documentos. Quedan disponibles al instante, sin desarrollo de por medio.',
      },
      {
        titulo: 'Equipos con permisos',
        descripcion:
          'Cada área publica en lo suyo: se asignan responsables por categoría y un administrador controla el resto.',
      },
    ],
  },

  // Sección de contacto: a definir con mercadeo (correo, teléfono y texto de cierre).
  contacto: {
    titulo: '¿Quieres publicar con nosotros?',
    descripcion: 'Cuéntanos qué necesita tu organización y preparamos una demostración.',
    email: null,
    asuntoCorreo: 'Información sobre PUSAH',
    telefono: null,
  },

  // Pie de página: aviso legal o enlace a políticas, cuando exista.
  legal: {
    aviso: null,
  },
};

export default PORTAL;
